import {
  AnswersApi,
  createAnswersApi,
  createApiTestKit,
} from '@wix/answers-api';
import { noop } from '@wix/answers-lib';
import moment from 'moment';
import React from 'react';

import { PageTemplateData } from '../components/PageTemplate';
import { ANSWERS_API_BASE_URL } from '../constants';
import { PageType, SessionBI, SiteMetaData, SiteSelectorData } from '../types';
import { createHttpService } from '../utils/answers';

export const answersApi = createAnswersApi({
  baseUrl: ANSWERS_API_BASE_URL,
  http: createHttpService(),
  clientName: 'helpcenter',
});

export type ContextType = {
  pageTemplateData: PageTemplateData;
  setPageTemplateData: (pageTemplateData: PageTemplateData) => void;
  answersApi: AnswersApi;
  isMobile: boolean;
  isTablet: boolean;
  experiments: { scopes: string[] };
  pageType: PageType;
  sessionBI: SessionBI;
  setSessionBI: (obj: SessionBI) => void;
  fetchSessionDebounceBI: (isLoggedInUser: boolean) => Promise<string | null>;
  siteSelectorData: SiteSelectorData;
  setUserSelectedSite: (site?: SiteMetaData | null) => void;
  showSearchModal: boolean;
  setShowSearchModal: (showSearchModal: boolean) => void;
};

export const Context = React.createContext<ContextType>({
  answersApi,
  pageTemplateData: {},
  setPageTemplateData: noop,
  isMobile: false,
  isTablet: false,
  experiments: { scopes: [] },
  pageType: PageType.Homepage,
  sessionBI: {
    lastSessionDate: moment(),
    selfServiceSessionId: null,
  },
  setSessionBI: noop,
  fetchSessionDebounceBI: noop,
  siteSelectorData: {
    itemsCount: 0,
    sites: [],
    selectedSite: undefined,
    lastInteractedSite: null,
  },
  setUserSelectedSite: noop,
  showSearchModal: false,
  setShowSearchModal: noop,
});

export const TestContextProvider = (props: {
  value: Partial<ContextType>;
  children: JSX.Element;
}) => (
  <Context.Provider
    value={{
      answersApi: createApiTestKit(),
      pageTemplateData: {},
      setPageTemplateData: noop,
      isMobile: false,
      isTablet: false,
      experiments: { scopes: [] },
      pageType: PageType.Homepage,
      sessionBI: {
        lastSessionDate: moment(),
        selfServiceSessionId: null,
      },
      setSessionBI: noop,
      fetchSessionDebounceBI: noop,
      showSearchModal: false,
      siteSelectorData: {
        itemsCount: 0,
        sites: [],
        selectedSite: undefined,
        lastInteractedSite: null,
      },
      setUserSelectedSite: noop,
      setShowSearchModal: noop,
      ...props.value,
    }}
  >
    {props.children}
  </Context.Provider>
);
